import { LoadingButton } from '@mui/lab';
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../api/login';
import { FONT_STYLE, PAGES_SLUGS } from '../../variables';
import PopupNotification from '../PopupNotification/PopupNotification';
import RegisterSuccess from './RegisterSuccess';

const NewAccountForm = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [notificationProps, setNotificationProps] = useState({
    isOpened: false,
    type: '',
    successMessage: 'Registo submetido com sucesso',
    errorMessage: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmationPassword, setShowConfirmationPassword] =
    useState(false);
  const [formData, setFormData] = useState({
    taxNumber: undefined,
    customerId: undefined,
    password: undefined,
    confirmPassword: undefined,
    fastRegister: true,
  });
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] =
    useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    registerUser(formData)
      .then(() => {
        setIsLoading(false);
        setShowConfirmation(true);
        setNotificationProps((prevState) => ({
          ...prevState,
          isOpened: true,
          type: 'success',
        }));
      })
      .catch(({ response: { status, data } }) => {
        const errorMessage = data?.msg || data?.errors?.[0]?.msg;
        if (status === 401) {
          navigate('/login');
        } else if (status === 400 || status > 401) {
          setIsLoading(false);
          setNotificationProps((prevState) => ({
            ...prevState,
            isOpened: true,
            type: 'error',
            errorMessage: errorMessage,
          }));
        }
      });
  };

  if (showConfirmation) {
    return <RegisterSuccess />;
  }

  return (
    <Box
      component='form'
      onSubmit={handleSubmit}
      autoComplete='off'
      sx={{
        width: { xs: '80vw', md: '30vw' },
        marginTop: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          textAlign: 'center',
          fontWeight: FONT_STYLE.bold,
          maxWidth: { lg: '50%' },
        }}
      >
        Registo de nova conta para clientes Frescas Surpresas
      </Typography>

      <Box
        sx={{
          display: { xs: 'block', sm: 'flex' },
          gap: 2,
          width: '100%',
        }}
      >
        <TextField
          fullWidth
          type='number'
          name='taxNumber'
          required
          label='NIF'
          value={formData.taxNumber}
          onChange={handleChange}
          error={formData.taxNumber === ''}
          helperText={formData.taxNumber === '' && 'Campo obrigatório.'}
        />

        <Box
          sx={{
            width: '100%',
          }}
        >
          <TextField
            fullWidth
            type='number'
            name='customerId'
            required
            label='Código de cliente'
            value={formData.customerId}
            onChange={handleChange}
            error={formData.customerId === ''}
            helperText={formData.customerId === '' && 'Campo obrigatório.'}
          />
          <Typography
            sx={{
              fontSize: '0.8rem',
              marginTop: 0.5,
            }}
          >
            (Código presente na sua fatura)
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
        }}
      >
        <TextField
          fullWidth
          label='Email'
          type='email'
          name='email'
          value={formData.email}
          onChange={handleChange}
          error={formData.email === ''}
          helperText={formData.email === '' && 'Campo obrigatório.'}
        />
        <Typography
          sx={{
            fontSize: '0.8rem',
            marginTop: 0.5,
          }}
        >
          (O e-mail será utilizado para receber informações da plataforma)
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: { xs: 'block', sm: 'flex' },
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            display: { xs: 'block', sm: 'flex' },
            gap: 2,
            width: '100%',
          }}
        >
          <TextField
            fullWidth
            required
            name='password'
            label='Palavra-passe'
            type={showPassword ? 'text' : 'password'}
            value={formData.password}
            error={formData.password === ''}
            helperText={formData.password === '' && 'Campo obrigatório.'}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <FiEye size={18} />
                    ) : (
                      <FiEyeOff size={18} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            required
            name='confirmPassword'
            label='Confirmar Palavra-passe'
            type={showConfirmationPassword ? 'text' : 'password'}
            value={formData.confirmPassword}
            error={
              formData.confirmPassword === '' ||
              formData.confirmPassword !== formData.password
            }
            helperText={
              formData.confirmPassword === ''
                ? 'Campo obrigatório.'
                : formData.confirmPassword !== formData.password
                ? 'As palavras-passe não coincidem.'
                : null
            }
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={() =>
                      setShowConfirmationPassword(!showConfirmationPassword)
                    }
                  >
                    {showConfirmationPassword ? (
                      <FiEye size={18} />
                    ) : (
                      <FiEyeOff size={18} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Typography
          sx={{
            width: '100%',
            fontSize: '0.8rem',
            marginTop: 1,
          }}
        >
          (A password deve conter no mínimo 8 caracteres com pelo menos 1 letra
          maiúscula, 1 letra minúscula, 1 algarismo e 1 caracter especial)
        </Typography>
      </Box>

      <Box
        sx={{
          width: 'inherit',
          marginTop: 2,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              onChange={() =>
                setTermsAndConditionsAccepted(!termsAndConditionsAccepted)
              }
            />
          }
          label={
            <Typography
              variant='small'
              sx={{
                '& a': {
                  textDecoration: 'underline',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: `Li e aceito de acordo com os  
                <a
                  href='/${PAGES_SLUGS.institutional.termsAndConditions}'
                  target='_blank'
                  title='Termos e Condições'
                >
                  Termos e Condições
                </a>
            `,
              }}
            />
          }
        />
      </Box>

      <LoadingButton
        variant='contained'
        type='submit'
        title='Submeter registo'
        loading={isLoading}
        sx={{
          marginTop: 3,
        }}
        disabled={
          formData.confirmPassword !== formData.password ||
          !termsAndConditionsAccepted
            ? true
            : false
        }
      >
        Submeter registo
      </LoadingButton>

      <PopupNotification
        notificationProps={notificationProps}
        setNotificationProps={setNotificationProps}
      />
    </Box>
  );
};

export default NewAccountForm;
